module.exports = __webpack_public_path__ + "img/rule01.098ca655.png";